import 'slick';

( function( $ ) {
	'use strict';

	$( '.pullquote-slider__wrapper' ).each( function(){
		const $this = $( this );
		if ( 1 < $this.children().length ) {
			$this.slick( {
				arrows: false,
				dots: true,
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 500,
				autoplaySpeed: 5000,
				pauseOnHover: true,
				mobileFirst: true,
				swipe: true,
				fade: true,
				autoplay: true,
				adaptiveHeight: true
			} );
		}
	} );
} )( jQuery );